import { Card } from "@hdi-seguros/web-components.card";


export const CardSkeletons = () => {
    return (
        <>
            <Card title="" loading />
            <Card title="" loading />
            <Card title="" loading />
            <Card title="" loading />
        </>
    )
}
